module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticStyle: {
      "margin-top": "50px",
      "margin-bottom": "40px",
      "text-align": "center"
    }
  }, [_vm._v("\n        ADA 订单管理\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "margin": "auto"
    }
  }, [_c('a-form', {
    staticClass: "login-form",
    attrs: {
      "id": "components-form-demo-normal-login",
      "form": _vm.form
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ([
        'userName',
        {
          rules: [{
            required: true,
            message: 'Please input your username!'
          }]
        } ]),
      expression: "[\n            'userName',\n            { rules: [{ required: true, message: 'Please input your username!' }] },\n          ]"
    }],
    attrs: {
      "placeholder": "请输入登录名"
    }
  }, [_c('a-icon', {
    staticStyle: {
      "color": "rgba(0,0,0,.25)"
    },
    attrs: {
      "slot": "prefix",
      "type": "user"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ([
        'password',
        {
          rules: [{
            required: true,
            message: 'Please input your Password!'
          }]
        } ]),
      expression: "[\n            'password',\n            { rules: [{ required: true, message: 'Please input your Password!' }] },\n          ]"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    }
  }, [_c('a-icon', {
    staticStyle: {
      "color": "rgba(0,0,0,.25)"
    },
    attrs: {
      "slot": "prefix",
      "type": "lock"
    },
    slot: "prefix"
  })], 1)], 1), _vm._v(" "), _c('a-form-item', [_c('a-button', {
    staticClass: "login-form-button",
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("\n          登录\n        ")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3b90ee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/login.vue
// module id = 1400
// module chunks = 1